import React from 'react';

const Loading = () => (
  <div className="text-center">
    <h1>
      <i className="fa fa-spinner fa-spin" />
    </h1>
  </div>
);

export default Loading;
